import { forwardRef } from "react";

const InputField = forwardRef(
  ({ label, error, helperLink, helperText, children, ...rest }, ref) => (
    <div className={error ? "field error" : "field"}>
      {label && (
        <label htmlFor={rest.id}>
          {label} {error && <span className="required-mark">*</span>}
        </label>
      )}
      <input ref={ref} {...rest} />
      {helperText && !error && (
        <span className="helper-text">{helperText}</span>
      )}
      {error && error !== ` ` && <span className="error-msg">{error}</span>}
      {helperLink}
      {children}
    </div>
  )
);

export default InputField;
